import instance from "../axios/axios";

// Fetch all employees with pagination and search
export const getEmployees = async ({ page, limit, search }) => {
    try {
        const response = await instance.get(`/api/employee/employees?page=${page}&limit=${limit}&search=${search}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Fetch employees for dropdown
export const fetchEmployeesForDropdown = async () => {
    try {
      const response = await instance.get("/api/employee/employees/dropdown");
      return response.data.data;
    } catch (error) {
      console.error("Failed to fetch employee", error);
      return [];
    }
  };


// Fetch a single employee by ID
export const getEmployeeById = async (id) => {
    try {
        const response = await instance.get(`/api/employee/employees/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Create a new employee
export const createEmployee = async (employeeData) => {
    try {
        const response = await instance.post(`/api/employee/employees`, employeeData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Update an existing employee
export const updateEmployee = async (id, employeeData) => {
    try {
        const response = await instance.put(`/api/employee/employees/${id}`, employeeData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Delete an employee
export const deleteEmployee = async (id) => {
    try {
        const response = await instance.delete(`/api/employee/employees/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};